import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AutoDirectService } from '../../services/auto-direct.service';
import { IAutoDirectSetting } from '../../interfaces/auto-direct-settings';
import { SupplierService } from '../../services/supplier.service';
import { TaskService } from '../../services/task.service';
import { Message } from '../../classes/Message';
import { MessageService } from 'primeng/api';
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'auto-direct-settings',
  styleUrls: ['./auto-direct-settings.component.scss'],
  templateUrl: 'auto-direct-settings.component.html',
})
export class AutoDirectSettingsComponent implements OnInit {
  public formGroup: UntypedFormGroup;
  public displayDialog = false;
  title = 'autodirect-settings';
  settingList: IAutoDirectSetting[];
  selectedSetting: IAutoDirectSetting;

  supplierClassifications: any[];
  supplierClassificationsInput: any;
  supplierClassificationList: any;

  supplierContractTypes: any[];
  supplierContractTypesInput: any;
  supplierContractTypeList: any;

  jobTaskTypes: any[];
  jobTaskTypeInput: any;
  jobTaskTypeList: any;
  jobTaskTypeLookup: any[];
  defaultTaskTypes: number[];
  defaultClassifications: number[];
  defaultContractTypes: number[];

  constructor(
    private autoDirectService: AutoDirectService,
    private messageService: MessageService,
    private supplierService: SupplierService,
    private customerService: CustomerService,
    private formBuilder: UntypedFormBuilder,
    private taskService: TaskService,
  ) {}

  async ngOnInit() {
    this.initForm();
    this.fetchClassifications();
    this.fetchContractTypes();
    this.fetchTaskTypes();
    this.fetchSettings();
  }

  fetchSettings() {
    this.autoDirectService.getSettings().then((x) => {
      this.settingList = [];

      x.map((y) => {
        y.jobTaskTypeList = y.jobTaskTypes != null ? y.jobTaskTypes.split(',').map(Number) : [];
      });

      this.settingList = x.sort((a, b) => {
        return a.sequence - b.sequence;
      });
    });
  }

  public fetchClassifications() {
    this.supplierService.getSupplierClassifications().then((x) => {
      this.supplierClassifications = x.map((item) => {
        return { label: item, value: item };
      });
      this.defaultClassifications = x.map((item) => item);
    });
  }

  public fetchContractTypes() {
    this.customerService.getContractTypes().then((x) => {
      this.supplierContractTypes = x.map((item) => {
        return { label: item.name, value: item.id };
      });
      this.defaultContractTypes = x.map((item) => item);
    });
  }

  public fetchTaskTypes() {
    this.taskService.GetTaskTypes().then((x) => {
      this.jobTaskTypeLookup = [];
      this.jobTaskTypeList = x.map((item) => {
        return { label: item.name, value: item.id };
      });
      this.defaultTaskTypes = x.map((item) => {
        return item.id;
      });

      x.forEach((tt) => {
        this.jobTaskTypeLookup[tt.id] = tt.name;
      });
    });
  }

  editSetting() {
    this.autoDirectService.getSetting(this.selectedSetting.id).then((x) => {
      let taskTypeList = [];

      this.formGroup.patchValue(x);

      if (x.jobTaskTypes != null) {
        taskTypeList = x.jobTaskTypes.split(',');
      }

      if (x.jobTaskTypes) {
        this.formGroup.patchValue({ jobTaskTypesInput: taskTypeList });
      }

      if (x.supplierClassifications != null && x.supplierClassifications.length > 0) {
        this.formGroup.patchValue({
          supplierClassificationsInput: x.supplierClassifications.split(','),
        });
      } else {
        this.formGroup.patchValue({ supplierClassificationsInput: [] });
      }

      if (x.supplierContractTypes != null && x.supplierContractTypes.length > 0) {
        this.formGroup.patchValue({
          supplierContractTypesInput: x.supplierContractTypes.split(','),
        });
      } else {
        this.formGroup.patchValue({ supplierContractTypesInput: [] });
      }

      this.displayDialog = true;
    });
  }

  createSetting() {
    this.initForm();
    this.displayDialog = true;
  }

  initForm() {
    this.formGroup = this.formBuilder.group({
      id: [''],
      enabled: [true],
      settingName: ['', Validators.required],
      sequence: ['', Validators.required],
      hoursUntilNextSequence: [''],
      prioritiseLessBusy: [true],
      minAlerts: [''],
      maxAlerts: ['', Validators.required],
      maxDirected: ['', Validators.required],
      maxDistanceToPickup: ['', Validators.required],
      maxDistanceToDropoff: ['', Validators.required],
      jobTotalDistanceMin: ['', Validators.required],
      jobTotalDistanceMax: ['', Validators.required],
      sendAlerts: [''],
      returnJourneyPercentage: ['', Validators.required],
      addToDirected: [''],
      supplierClassificationsInput: [this.defaultClassifications],
      supplierContractTypesInput: [this.defaultContractTypes],
      jobTaskTypesInput: [this.defaultTaskTypes],
      busyHours: ['', Validators.required],
    });
  }

  async Save() {
    if (this.formGroup.invalid) {
      return;
    }

    let formValues = this.formGroup.value;
    let saveObject = <IAutoDirectSetting>formValues;

    saveObject.supplierClassifications = this.f.supplierClassificationsInput.join(',');
    saveObject.supplierContractTypes = this.f.supplierContractTypesInput.join(',');
    saveObject.jobTaskTypes = this.f.jobTaskTypesInput.join(',');

    this.autoDirectService
      .saveSetting({ autoDirectSetting: saveObject })
      .then(() => {
        this.displayDialog = false;
        this.fetchSettings();
      })
      .catch((error) => {
        let msg =
          error.error && error.error.Message ? error.error.Message : 'Error saving alert setting';
        this.messageService.add(Message.Error(`${msg}`));
      });
  }

  get f() {
    return this.formGroup.value;
  }

  enabledSwitchChanged($event: any, item: any) {
    let saveObject = { id: item.id, enabled: item.enabled };

    this.autoDirectService
      .saveSetting({ autoDirectSetting: saveObject })
      .then(() => {})
      .catch((error) => {
        let msg =
          error.error && error.error.Message ? error.error.Message : 'Error saving alert setting';
        this.messageService.add(Message.Error(`${msg}`));
      });
  }
}
